import { Select } from "antd";
import { FC } from "react";

const SelectMarketField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="bazar" >کافه بازار</Select.Option>
      <Select.Option key="myket" >مایکت</Select.Option>
    </Select>
  )
}

export default SelectMarketField
